import { shape, string } from "prop-types"

export const UserClassificationShape = shape({
    userClassificationId: string.isRequired,
    userId: string.isRequired,
    effectiveDate: string.isRequired,
    classificationId: string.isRequired
})